import type { SVGProps } from 'react'
import * as React from 'react'

const paginationPageNextIcon = (props: SVGProps<SVGSVGElement>) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 9L12 15L18 9" stroke="#78787A" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default paginationPageNextIcon
